export function IdeozLogo(): JSX.Element {
  return (
    <div className="h-[43.207px] relative shrink-0 w-[60.998px]" data-name="Ideoz Logo 2025">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 61 44">
        <g id="Ideoz Logo 2025">
          <g id="Group 1">
            <ellipse
              cx="5.16254"
              cy="5.9492"
              fill="#344054"
              id="Ellipse 1"
              rx="5.16254"
              ry="5.16228"
            />
            <path
              d="M0.379787 16.0072C0.379787 14.784 1.37146 13.7924 2.59476 13.7924H7.73702C8.96031 13.7924 9.95199 14.784 9.95199 16.0072V40.9918C9.95199 42.215 8.96031 43.2066 7.73702 43.2066H2.59476C1.37146 43.2066 0.379787 42.215 0.379787 40.9918V16.0072Z"
              fill="#344054"
              id="Vector"
            />
          </g>
          <g id="ideoz">
            <path
              d="M35.0991 37.3903C35.0991 37.2964 35.023 37.2203 34.9291 37.2203V37.2203C34.8533 37.2203 34.7868 37.2707 34.7647 37.3433C34.5249 38.1329 34.1593 38.8866 33.668 39.6043C33.1512 40.3195 32.5151 40.9553 31.7598 41.5115C31.0442 42.0281 30.2094 42.4254 29.2553 42.7035C28.3409 43.0214 27.3868 43.1803 26.393 43.1803C22.4176 43.1803 19.4161 41.7897 17.3887 39.0083C15.3612 36.1872 14.3475 32.1146 14.3475 26.7903C14.3475 21.466 15.3612 17.4132 17.3887 14.6318C19.4161 11.8505 22.4176 10.4598 26.393 10.4598C28.4204 10.4598 30.2094 11.0161 31.7598 12.1286C33.3114 13.2142 34.3142 14.6024 34.7681 16.2932C34.7881 16.3674 34.8548 16.4198 34.9317 16.4198V16.4198C35.0242 16.4198 35.0991 16.3449 35.0991 16.2524V1.10743C35.0991 0.495814 35.595 0 36.2066 0H42.817C43.4287 0 43.9245 0.495814 43.9245 1.10743V41.3577C43.9245 41.9693 43.4287 42.4651 42.817 42.4651H36.2066C35.595 42.4651 35.0991 41.9693 35.0991 41.3577V37.3903ZM29.3149 36.0283C30.9846 36.0283 32.3561 35.631 33.4294 34.8363C34.5426 34.0019 35.0991 32.8695 35.0991 31.4391V22.2011C35.0991 20.7707 34.5426 19.6581 33.4294 18.8635C32.3561 18.0291 30.9846 17.6119 29.3149 17.6119C27.6452 17.6119 26.2538 18.2079 25.1407 19.3999C24.0674 20.5521 23.5307 22.1216 23.5307 24.1083V29.5319C23.5307 31.5186 24.0674 33.1079 25.1407 34.2999C26.2538 35.4522 27.6452 36.0283 29.3149 36.0283Z"
              fill="#344054"
              id="Vector_2"
            />
          </g>
          <ellipse
            cx="55.8352"
            cy="38.0423"
            fill="#344054"
            id="Ellipse 5"
            rx="5.16254"
            ry="5.16228"
          />
        </g>
      </svg>
    </div>
  );
}
